import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import WebService from '../utility/WebService';
import './AppPayment.scss';

const AppPayment = () => {
    const navigate = useNavigate();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = encodeURIComponent(urlParams.get('token') || "")
    const [isLoading, setLoading] = useState(false);
    const tokenData = useRef<any>();
    const paymentResponse = useRef<any>();
    const token = useRef('');
    const [isPaymentDone, setIsPaymentDone] = useState(false);
    const [isShowError, setShowError] = useState(false);
    const [payment, setPayment] = useState('');
    const [paymentData, setPaymentData] = useState<any>();

    useEffect(() => {
        if (value) {
            setPaymentData(null)
            getAccessToken()
        }
    }, [value])

    useEffect(() => {
        if (paymentResponse.current) {
            onMakePayment(paymentResponse.current)
        }
    }, [isPaymentDone])

    const getAccessToken = () => {
        setLoading(true)
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken-CC?id=${value}`)
            .then((res) => {
                token.current = res.data.accessToken
                tokenData.current = res.data.data
                localStorage.setItem('token', res.data.accessToken)
                localStorage.setItem('tenant_url', res.data.tenantUrl)
                if (res.data.data.companyCode && res.data.data.amountToCharge) {
                    getAuthorizationKey(res.data.data)
                } else {
                    setShowError(true)
                }
            })
            .catch((e) => {
                setShowError(true)
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
            })
    }

    const getAuthorizationKey = (data: any) => {
        setLoading(true)
        WebService.postAPI({
            action: `api/CreditCard/GetFSAuthenticationKey`,
            body: {
                CompanyCode: data.companyCode
            }
        })
            .then((res: any) => {
                setLoading(false)
                openModal(res.data.authenticationKey, res.data.hostedPaymentURL, data)
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
            })
    }

    const openModal = (key: string, hostedPaymentURL: string, tokenData: any) => {
        var data: any = {
            "authenticationKey": key,// should get from server
            "operationType": "HostedPaymentsAccountId",
            "paymentSourceType": "Card",
            "cardEntryContext": "WebConsumerInitiated",
            "achAuthorizationType": "Web",
            "nameOnAccountField": "NameOnAccount",
            "zipField": "Zip",
            "showNameOnAccount": true,
            "showZip": true,
            "formId": "tokenForm",
            "completionCallback": "",
            "hostedPaymentURL":hostedPaymentURL
        };

        if (key) {
            const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT");
            data.total_amount = tokenData.amountToCharge && tokenData.amountToCharge.toFixed(2)
            channel.postMessage(data);
        }
    };


    const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT_CALLBACK");
    channel.onmessage = (event) => {
        if (event?.data && isPaymentDone == false) {
            setIsPaymentDone(true)
            paymentResponse.current = event.data
        }
    };

    const onMakePayment = (data: any) => {
        var value = data && JSON.parse(data)
        if (value.gatewayResponse.hostedPaymentsAccountId) {
            if (tokenData.current.cashReceipts == null || tokenData.current.cashReceipts.length == 0) {
                setLoading(true)
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token.current,
                };

                axios.post(`${WebService.getUrl()}api/CreditCard/ChargeWithTokenMultipleInvoicesNewCard`, {
                    CompanyCode: tokenData.current.companyCode,
                    NewCardToken: value.gatewayResponse?.hostedPaymentsAccountId,
                    BillTo: tokenData.current.billTo,
                    AmountToCharge: tokenData.current.amountToCharge,
                    UserNumber: tokenData.current.userNumber,
                    UserName: tokenData.current.userName,
                    UserType: tokenData.current.userType,
                    Invoices: tokenData.current.invoices,
                    Comments: '',
                    sendReceiptToEmail: '',
                    sendReceiptToPhone: ''

                }, {
                    headers: headers
                })
                    .then((res) => {
                        setPaymentData(res.data)
                        if (res.data.success == false) {
                            navigate(`/app-payment-status`)
                            setPayment('ERROR')
                            toast.error(res.data?.errorInfo?.message)
                        } else {
                            navigate(`/app-payment-status`)
                            setPayment('SUCCESS')
                            toast.success(res.data?.data?.status)
                        }
                        setLoading(false)
                    })
                    .catch((e) => {
                        navigate(`/app-payment-status`)
                        setLoading(false)
                        toast.error(e?.response?.data?.errorInfo?.message)
                    })
            } else {
                setLoading(true)
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token.current,
                };

                axios.post(`${WebService.getUrl()}api/CreditCard/ChargeWithNewCardCreditReceipt`, {
                    CompanyCode: tokenData.current.companyCode,
                    NewCardToken: value.gatewayResponse?.hostedPaymentsAccountId,
                    BillTo: tokenData.current.billTo,
                    AmountToCharge: tokenData.current.amountToCharge,
                    UserNumber: tokenData.current.userNumber,
                    UserName: tokenData.current.userName,
                    UserType: tokenData.current.userType,
                    CashReceipts: tokenData.current.cashReceipts
                }, {
                    headers: headers
                })
                    .then((res) => {
                        setPaymentData(res.data)
                        if (res.data.success == false) {
                            navigate(`/app-payment-status`)
                            setPayment('ERROR')
                            toast.error(res.data?.errorInfo?.message)
                        } else {
                            navigate(`/app-payment-status`)
                            setPayment('SUCCESS')
                            toast.success(res.data?.data?.status)
                        }
                        setLoading(false)
                    })
                    .catch((e) => {
                        navigate(`/app-payment-status`)
                        setLoading(false)
                        toast.error(e?.response?.data?.errorInfo?.message)
                    })
            }
        }
    }

    return (
        <>
            <Loader show={isLoading} />
            {
                isShowError &&
                <div className='app-payment-error'>
                    <div className='payment-error'>Invalid Token</div>
                </div>
            }
            {
                payment == 'SUCCESS' &&
                <div className='app-payment-error'>
                    <div className='d-flex'>
                        <div className='payment-error'>Status: &nbsp;</div>
                        <span style={{ color: 'green' }}>{paymentData?.data?.status}</span>
                    </div>
                    <div className='d-flex'>
                        <div className='payment-error'>Transaction Id: &nbsp;</div>
                        <span>{paymentData?.data?.transactionId}</span>
                    </div>
                    <div className='d-flex'>
                        <div className='payment-error'>Auth Code: &nbsp;</div>
                        <span>{paymentData?.data?.authCode}</span>
                    </div>
                    <div className='d-flex'>
                        <div className='payment-error'>Amount: &nbsp;</div>
                        <span>${tokenData.current.amountToCharge && tokenData.current.amountToCharge.toFixed(2)}</span>
                    </div>
                </div>
            }
            {
                payment == 'ERROR' &&
                <div className='app-payment-error'>
                    <div className='d-flex'>
                        <div className='payment-error'>Status: &nbsp;</div>
                        <span style={{ color: 'red' }}>{paymentData?.data?.status}</span>
                    </div>
                    <div className='d-flex'>
                        <div className='payment-error'>Message: &nbsp;</div>
                        <span>{paymentData?.errorInfo?.message}</span>
                    </div>
                </div>
            }
        </>
    )
}

export default AppPayment;